import React, {Component} from 'react';
import request from '../../../../base/request';
import {getInfoFromLocalStorage} from "../../../../actions";
import $ from "jquery";
import {uuid} from "../../../../utils";
import ReactDOM from 'react-dom';
import SyncModal from "../../../components/syncModal/syncModal";
import {Input, message} from "antd";

const {TextArea} = Input;

/**
 * 手动推流程，同时弹出备注按钮
 * */
export default function renderRemarkBtn({ component, activitiCategoryKey, btnName, taskName,refuseDate, condition,conditionFun, record, notNull=false,remarkFieldName="refuseReason"}){
    return {name: btnName, condition, conditionFun, onOk: ({id, btnInfo,version})=>{
        let uuId = `a${uuid()}`;
        $(document.body).append(`<div id='${uuId}'></div>`);
        let syncModal = null;
        ReactDOM.render(<SyncModal ref={ref => syncModal = ref}/>, document.getElementById(uuId));
        let remarks = "";
        syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea placeholder={"请输入"} onChange={e=>remarks=e.target.value} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}/>,
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
                if(notNull){//校验是否必填
                    if(!remarks){
                        message.destroy();
                        message.warning("请填写备注！");
                        return;
                    }
                }
                let fun = ()=>{
                    component.update({
                        id: id || record.id, status: taskName, refuseDate, version, btnInfo, activiti: {}, call: ({status}) => {
                            if (status) {
                                message.destroy();
                                message.success(btnName+'成功');
                                component.hide();
                                component.props.callBack();
                            } else {
                                message.destroy();
                                message.error("网络出错，请稍等重试");
                            }
                        }, otherParams:(()=>{
                            let obj =  {};
                            obj[remarkFieldName] = remarks;
                            return obj;
                        })()
                    });
                };
                if(activitiCategoryKey){
                    activityCone({taskName, record, remarks, call:()=>{
                        fun();
                    }, activitiCategoryKey});
                }else{
                    fun();
                }
                syncModal.destroy();
                $(`#${uuId}`).remove();
            },
            onCancel: () => {
                syncModal.destroy();
                $(`#${uuId}`).remove();
            }
        })
    }}
}

/**
 * 手动推流程
 * @param taskName
 * @param record
 * @param remarks
 * @param call
 * @param activitiCategoryKey
 */
function activityCone({taskName, record, remarks, call, activitiCategoryKey}) {
    let currentUser = getInfoFromLocalStorage("currentUser");
    let userId = currentUser.id;
    let deptId = currentUser.defaultInfo.dept.id;
    request({
        url: "/cm-sites-sys/process/done",
        method: "post",
        contentType: "json",
        body: {
            activitiCategoryKey,
            bizKey: record.id,
            title: record.title,
            record,
            operatorUserInfo: {userId,deptId},
            taskName,
            otherData: {remarks}
        },
        callBack: (res) => {
            if(res) {
                call&&call()
            }
        },
        errorCallBack: (e) => {
        },
    })
}
